const app = window.blueprintData;
export const globals = {
  moneyFormat: app.moneyFormat,
  moneyFormatWithCurrency: app.moneyFormatWithCurrency,
  enableZeros: app.enableZeros,
  enableCurrency: app.enableCurrency,
};
